import { render } from "./StoryDetail.vue?vue&type=template&id=26ac241c"
import script from "./StoryDetail.vue?vue&type=script&lang=js"
export * from "./StoryDetail.vue?vue&type=script&lang=js"

import "./StoryDetail.vue?vue&type=style&index=0&id=26ac241c&lang=css"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__